import * as PIXI from "pixi.js";
import { CENTER_ANGLE_COLOR, CIRCUM_ANGLE_COLOR } from "../../../../src/types/Config";
import degreeToRadian from "../../../../src/utils/degreeToRadian";

export const ANGLE_NAMES_FOR_ANIM = { circum: "x", center: "2x" };
export const CIRCLE_RADIUS = 200;
export const SIDE_1_DEGREE = 140;
export const SIDE_2_DEGREE = 40;
export const CIRCUM_DEGREE = 270;
export const RADIANS = [degreeToRadian(40), degreeToRadian(140), degreeToRadian(270)];
export const CENTER_OF_CIRCLE = { x: 500, y: 360 };
export const CALC_LINE_COORD = { x: 300, y: 600 }
export const GUIDE_TEXT_COORD = { x: 100, y: 20 }
export const SLIDERS_COORD = [{ x: 90, y: 800 }, { x: 450, y: 800 }, { x: 810, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: - 340, y: 480 }, { x: 120, y: 480 }, { x: - 110, y: 660 }];
export const INFO_SLIDER_COORD = { x: 1130, y: 200 };
export const BOUNDS_OF_COORD = { x: 1500, y: 800 }
export const ARC_COLOR_ARR = [0xFFBD06, 0x000000, 0x000000];

export const INFO_SLIDER_ASSETS = [
  "/circle-theorem-1/info-slider/1.jpeg",
  "/circle-theorem-1/info-slider/2.jpeg",
  "/circle-theorem-1/info-slider/3.jpeg",
  "/circle-theorem-1/info-slider/4.jpeg",
  "/circle-theorem-1/info-slider/5.jpeg",
  "/circle-theorem-1/info-slider/6.jpeg",
  "/circle-theorem-1/info-slider/7.jpeg",
  "/circle-theorem-1/info-slider/8.jpeg",
  "/circle-theorem-1/info-slider/9.jpeg",
  "/circle-theorem-1/info-slider/10.jpeg",
  "/circle-theorem-1/info-slider/11.jpeg",
  "/circle-theorem-1/info-slider/12.jpeg",
  "/circle-theorem-1/info-slider/13.jpeg",
  "/circle-theorem-1/info-slider/14.jpeg",
]

export const CALC_LINE_INITIAL_TEXT_OBJ = [{
  text: "2",
  x: 75,
  y: 0,
  color: 0x000000,
},
{
  text: "x",
  x: 109,
  y: 0,
  color: 0x000000,
  fontSize: 40,
},
{
  text: "x°",
  x: 150,
  y: 0,
  color: CIRCUM_ANGLE_COLOR.textColor,
  fontWeight: "600" as PIXI.TextStyleFontWeight
},
{
  text: "=",
  x: 259,
  y: 0,
  color: 0x000000,
},
{
  text: "2x°",
  x: 300,
  y: 0,
  color: CENTER_ANGLE_COLOR.textColor,
  fontWeight: "600" as PIXI.TextStyleFontWeight
}]